import React from 'react';
import { Box, Grommet } from 'grommet';
import { hot } from 'react-hot-loader/root';
import AddBoardObjectsForm from './components/AddBoardObjectsArrayForm';
import Notifications from './components/Notifications';
import Layers from './components/Layers';

const App = () => {
  return (
    <Grommet full plain>
      <Box direction="column" align="center" gap="medium" pad="medium" fill>
        <AddBoardObjectsForm />
      </Box>
      <Layers />
      <Notifications />
    </Grommet>
  );
};

export default hot(App);
